import { pipi } from '@baseValues'
import { toVector3 } from '../../conversion/toVector3'

export function getInnerAngle<T extends [number, number]>(
  Sa: T,
  Ea: T,
  Sb: T,
  Eb: T,
  isLoneLine = false,
) {
  if (!Sa || !Ea || !Sb || !Eb) return { innerAngle: 0, cp: 0 }

  const StartA = toVector3(Sa)
  const StartB = toVector3(Sb)
  const EndA = toVector3(Ea)
  const EndB = toVector3(Eb)
  /*
->
*/
  const dir1 = toVector3(Ea).sub(toVector3(Sa)).normalize() // ->
  const dir2 = toVector3(Eb).sub(toVector3(Sa)).normalize() // v
  /**
   * ^
   */
  const crossProduct = dir1.clone().cross(dir2)
  const innerAngle = StartA.sub(EndA).angleTo(EndB.sub(StartB))

  if (isLoneLine) return { innerAngle, cp: crossProduct }
  return {
    innerAngle: Math.sign(crossProduct.y) >= 0 ? pipi - innerAngle : innerAngle,
    cp: Math.sign(crossProduct.y),
  }
}
